
import './Goals.css';
import React, { useState } from "react";
import glow from '../../assets/images/glow.png';
import power from '../../assets/images/power.png';
import RoutineGoal from './RoutineGoal.js';
import TargetGoal from './TargetGoal.js';
import AddTask from '../tasks/AddTask.js';
import MilestonePopUp from './milestones/MilestonePopUp.js';
import PillarSection from './pillars/PillarSection.js';
import ProjectSection from './pillars/ProjectSection.js';
import AddGoal from './AddGoal.js';
import EditGoal from './EditGoal.js';

function Goals(props) {
    const [showAddGoal, setShowAddGoal] = useState(false)
    const [showAddTask, setShowAddTask] = useState(false)
    const [showEditGoal, setShowEditGoal] = useState(false)
    const [showAddTaskMilestone, setShowAddTaskMilestone] = useState("")
    const [activeGoal, setActiveGoal] = useState("")
    let goals = props.userProfile.goals
    if (goals === null) {
        goals=[]
    }

    function resetShowTaskMilestone () {
        setShowAddTaskMilestone("")
        setActiveGoal("")
    }

    function clickOnMilestone(milestoneText) {
        setShowAddTaskMilestone(milestoneText)
        for (const goal of props.userProfile.goals) {
            if (goal.goalType === "milestone" && goal.milestones.includes(milestoneText)) {
                setActiveGoal(goal)
            }
        }
    }

    function editGoalButtonClick(goal) {
        setActiveGoal(goal)
        setShowEditGoal(true)
    }

    return (
        <div>
            {showAddGoal &&
                <AddGoal goals={goals} userProfile={props.userProfile} setUserProfile={props.setUserProfile} setShowAddGoal={setShowAddGoal} />}
            {showEditGoal &&
                <EditGoal activeGoal={activeGoal} userProfile={props.userProfile} setUserProfile={props.setUserProfile} setShowEditGoal={setShowEditGoal} />}
            {showAddTask && 
                <AddTask project={activeGoal} setShowAddTask={setShowAddTask} associatedMilestone={showAddTaskMilestone} tasks={props.userProfile.tasks} setTasks={props.setTasks} userProfile={props.userProfile} setUserProfile={props.setUserProfile}/>}
            {showAddTaskMilestone !== "" && 
                <MilestonePopUp userProfile={props.userProfile} setUserProfile={props.setUserProfile} resetShowTaskMilestone={resetShowTaskMilestone} setShowAddTask={setShowAddTask} associatedMilestone={showAddTaskMilestone}/> }
            <p onClick={() => setShowAddGoal(true)} className="addGoalButtonMain"> add goal</p>
            <p onClick={() => props.setActivePage("profile")} className="goToUserProfile"> edit user profile </p>
            <p className="taskHeaderText centerTaskHeaderText"> MY GOALS </p>
            <div className="goals">
                <img className="bodyImage glowImage" src={glow} alt="left half of the body, with two glowing blue lines inside the body, representing inner force" />
                {/* left section, glow goals */}
                <div className="goalsBoxOutline glowBox">
                    <p className="goalHeaderText"> GLOW </p>
                    <div className="verticalAccentLine line1"></div>
                    <div className="verticalAccentLine line2"></div>
                    <div className="verticalAccentLine line3"></div>
                    <div className="goalsBoxContent">
                        {goals.filter((goal) => goal.isGlowGoal).map((goal, index) => (
                            <div key={index} className="goalBox">
                                <p className="goalName"> {goal.title} </p>
                                {goal.goalType !== "routine" &&
                                    <TargetGoal setShowAddTaskMilestone={clickOnMilestone} steps={goal.milestones} />
                                }
                                {goal.goalType === "routine" &&
                                    <RoutineGoal />
                                }
                                <div className="row">
                                <p className="editGoalButton" onClick={() => editGoalButtonClick(goal)}> edit goal </p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <p className="goalFooterText"> your inner energy, surging from within </p>
                </div>
                {/* right section, power goals */}
                <div className="goalsBoxOutline powerBox">
                    <p className="goalHeaderText"> POWER </p>
                    <div className="verticalAccentLine line1"></div>
                    <div className="verticalAccentLine line2"></div>
                    <div className="verticalAccentLine line3"></div>
                    <div className="goalsBoxContent">
                        {goals.filter((goal) => !goal.isGlowGoal).map((goal, index) => (
                            <div key={index} className="goalBox">
                                <p className="goalName"> {goal.title} </p>
                                <TargetGoal  setShowAddTaskMilestone={clickOnMilestone} steps={goal.milestones}/>
                                <p className="editGoalButton" onClick={() => editGoalButtonClick(goal)}> edit goal </p>
                            </div>
                        ))}
                    </div>
                    <p className="goalFooterText"> your outer energy, exuding your force </p>
                </div>
                <div className="bottomLine"></div>
                <img className="bodyImage powerImage" src={power} alt="right half of the body, with two glowing blue lines outside of the body, representing outer force" />
            </div>
            <ProjectSection userProfile={props.userProfile} />
            <PillarSection userProfile={props.userProfile} />
        </div>
    )
}

export default Goals;